import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33f46ef9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增配置")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 1,
  class: "btn_box"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "input_item" }
const _hoisted_11 = { class: "input_tag" }
const _hoisted_12 = { class: "input_item" }
const _hoisted_13 = { class: "input_tag" }
const _hoisted_14 = { class: "input_item" }
const _hoisted_15 = { class: "input_tag" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "input_item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_tag" }, "配置项：", -1))
const _hoisted_19 = {
  key: 0,
  class: "input_item"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_tag" }, "配置内容：", -1))
const _hoisted_21 = { class: "input_content" }
const _hoisted_22 = {
  key: 1,
  class: "input_item"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_tag" }, "配置内容：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ImageView = _resolveComponent("ImageView")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_UploadComponent = _resolveComponent("UploadComponent")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "网站配置",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setEditItem(undefined, true, true)))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: _ctx.columns,
          loading: _ctx.loading,
          rowKey: "id",
          bordered: "",
          pagination: false
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'content')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (record.is_json)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (record.tag === 'contact_information')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(text, (item) => {
                                return (_openBlock(), _createElementBlock("div", null, [
                                  _createElementVNode("div", null, _toDisplayString(item.address.title) + _toDisplayString(item.address.value), 1),
                                  _createElementVNode("div", null, _toDisplayString(item.tel.title) + _toDisplayString(item.tel.value), 1),
                                  _createElementVNode("div", null, _toDisplayString(item.email.title) + _toDisplayString(item.email.value), 1)
                                ]))
                              }), 256))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (record.tag === 'logo')
                          ? (_openBlock(), _createBlock(_component_ImageView, {
                              key: 0,
                              "image-url": text,
                              "on-change": _ctx.onImageChange
                            }, null, 8, ["image-url", "on-change"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(text), 1))
                      ]))
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    class: "btn",
                    onClick: ($event: any) => (_ctx.setEditItem(record, true, false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
      title: `配置${_ctx.editItem.tag || ''}`,
      onOk: _ctx.onEdit,
      onCancel: _ctx.getList,
      confirmLoading: _ctx.loading
    }, {
      default: _withCtx(() => [
        (_ctx.editItem.is_json)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_ctx.editItem.tag === 'contact_information')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editItem.content, (item) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, _toDisplayString(item.address.title), 1),
                          _createVNode(_component_a_textarea, {
                            class: "input_content",
                            value: item.address.value,
                            "onUpdate:value": ($event: any) => ((item.address.value) = $event),
                            placeholder: "请输入"
                          }, null, 8, ["value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, _toDisplayString(item.tel.title), 1),
                          _createVNode(_component_a_input, {
                            class: "input_content",
                            value: item.tel.value,
                            "onUpdate:value": ($event: any) => ((item.tel.value) = $event),
                            placeholder: "请输入"
                          }, null, 8, ["value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(item.email.title), 1),
                          _createVNode(_component_a_textarea, {
                            class: "input_content",
                            value: item.email.value,
                            "onUpdate:value": ($event: any) => ((item.email.value) = $event),
                            placeholder: "请输入"
                          }, null, 8, ["value", "onUpdate:value"])
                        ])
                      ]))
                    }), 256))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_a_input, {
                  class: "input_content",
                  value: _ctx.editItem.tag,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editItem.tag) = $event)),
                  placeholder: "请输入",
                  disabled: !_ctx.type
                }, null, 8, ["value", "disabled"])
              ]),
              (_ctx.editItem.tag === 'logo')
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_UploadComponent, {
                        ref: "updateComponentRef",
                        "source-url": _ctx.editItem.content
                      }, null, 8, ["source-url"])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _hoisted_23,
                    _createVNode(_component_a_textarea, {
                      class: "input_content",
                      value: _ctx.editItem.content,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editItem.content) = $event)),
                      placeholder: "请输入"
                    }, null, 8, ["value"])
                  ]))
            ]))
      ]),
      _: 1
    }, 8, ["visible", "title", "onOk", "onCancel", "confirmLoading"])
  ], 64))
}